// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Caption/Caption.sass
// module id = 353
// module chunks = 0